var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import OpportunityDomainService from "../Domain/Opportunity/Opportunity.service";
import WorkflowDomainService from "../Domain/Workflow/Workflow.service";
const BASE_URL = "/aviso/opportunity";
export default class OpportunityService {
    static get(opportunityId) {
        return FetchService.getSingleResponse(BASE_URL + "/get", {
            id: opportunityId,
        }).then(OpportunityDomainService.fromJSON);
    }
    static searchLite(searchLite, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                returnFullDto: false,
                populationIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.populationIds,
                stageIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.stageIds,
                pipelineIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.pipelineIds,
                pipelineStatusIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.pipelineStatusIds,
                pipelineEntryDateFrom: searchLite === null || searchLite === void 0 ? void 0 : searchLite.pipelineEntryDateFrom,
                pipelineEntryDateTo: searchLite === null || searchLite === void 0 ? void 0 : searchLite.pipelineEntryDateTo,
                assignedPersonIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.assignedPersonIds,
                opportunitySourceIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.opportunitySourceIds,
                createdByIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.createdByIds,
                modifiedByIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.modifiedByIds,
                createdDateFrom: searchLite === null || searchLite === void 0 ? void 0 : searchLite.createdDateFrom,
                createdDateTo: searchLite === null || searchLite === void 0 ? void 0 : searchLite.createdDateTo,
                modifiedDateFrom: searchLite === null || searchLite === void 0 ? void 0 : searchLite.modifiedDateFrom,
                modifiedDateTo: searchLite === null || searchLite === void 0 ? void 0 : searchLite.modifiedDateTo,
                subjectIds: searchLite === null || searchLite === void 0 ? void 0 : searchLite.subjectIds,
                query: searchLite === null || searchLite === void 0 ? void 0 : searchLite.query,
                stageUpdatedDateFrom: searchLite === null || searchLite === void 0 ? void 0 : searchLite.stageUpdatedDateFrom,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, response), { data: response.data.map(OpportunityDomainService.fromJSON) });
        });
    }
    static searchFull(searchFull, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                returnFullDto: true,
                populationIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.populationIds,
                stageIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.stageIds,
                pipelineIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.pipelineIds,
                pipelineStatusIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.pipelineStatusIds,
                pipelineEntryDateFrom: searchFull === null || searchFull === void 0 ? void 0 : searchFull.pipelineEntryDateFrom,
                pipelineEntryDateTo: searchFull === null || searchFull === void 0 ? void 0 : searchFull.pipelineEntryDateTo,
                assignedPersonIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.assignedPersonIds,
                opportunitySourceIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.opportunitySourceIds,
                createdByIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.createdByIds,
                modifiedByIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.modifiedByIds,
                createdDateFrom: searchFull === null || searchFull === void 0 ? void 0 : searchFull.createdDateFrom,
                createdDateTo: searchFull === null || searchFull === void 0 ? void 0 : searchFull.createdDateTo,
                modifiedDateFrom: searchFull === null || searchFull === void 0 ? void 0 : searchFull.modifiedDateFrom,
                modifiedDateTo: searchFull === null || searchFull === void 0 ? void 0 : searchFull.modifiedDateTo,
                subjectIds: searchFull === null || searchFull === void 0 ? void 0 : searchFull.subjectIds,
                query: searchFull === null || searchFull === void 0 ? void 0 : searchFull.query,
                stageUpdatedDateFrom: searchFull === null || searchFull === void 0 ? void 0 : searchFull.stageUpdatedDateFrom,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, response), { data: response.data.map(OpportunityDomainService.fromJSON) });
        });
    }
    static moveOpportunity(opportunityId, stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return OpportunityService.updateStage(opportunityId, stageId);
        });
    }
    static edit(opportunityEditRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.putSingleResponse(BASE_URL + "/edit", opportunityEditRequest).then(OpportunityDomainService.fromJSON);
        });
    }
    static updateStage(opportunityId, stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/updateStage", {
                opportunityId,
                stageId,
            }).then(OpportunityDomainService.fromJSON);
        });
    }
    static bulkUpdateStage(opportunityIds, stageId, pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkUpdateStage", {
                opportunityIds,
                stageId,
                pipelineId,
            });
        });
    }
    static removeFromPipeline(removeFromPipelineRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.deleteSingleResponse(BASE_URL + "/removeFromPipeline", {
                removeFromPipelineRequest,
            });
        });
    }
    static editAssignee(opportunityId, personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.putSingleResponse(BASE_URL + "/editAssignee", {
                opportunityId,
                personId,
            }).then(OpportunityDomainService.fromJSON);
        });
    }
    static bulkEditAssignee(opportunityIds, assigneeId, pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkEditAssignee", {
                opportunityIds,
                assigneeId,
                pipelineId,
            });
        });
    }
    static cancelWorkFlow(opportunityId, stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.putSingleResponse(BASE_URL + "/cancelWorkFlow", {
                opportunityId,
                stageId,
            });
        });
    }
    static getWorkflow(stageId, contextPersonId) {
        return FetchService.getSingleResponse(BASE_URL + "/getWorkflow", {
            stageId,
            contextPersonId,
        }).then(WorkflowDomainService.fromJSON);
    }
    static resumeWorkflow(opportunityId, stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.putSingleResponse(BASE_URL + "/resumeWorkflow", {
                opportunityId,
                stageId,
            });
        });
    }
    static copy(opportunityId, pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/copy", {
                opportunityId,
                pipelineId,
            });
        });
    }
    static bulkCopy({ opportunityIds, pipelineId, assigneeId, stageId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkCopy", {
                opportunityIds,
                pipelineId,
                assigneeId,
                stageId,
            });
        });
    }
}
